import { DateTime } from 'luxon';
import { Guid } from '../guid';
import { CanvasDocument } from '@react-email-dnd/shared';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { ObjectState } from '../../enums/objectState.enum';

export class EmailTemplateConfig implements IConfigObjectBase {
	id: string = Guid();
	version = '1.0.0';
	name = '';
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	htmlString = '';
	templateDocument: CanvasDocument | string = '';
	objectState?: ObjectState | undefined;

	constructor(init?: Partial<EmailTemplateConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
